import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, FIREBASE_EVENTS, SERVICES_CARDS_TAGS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function StoreCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { isEligibleToBuy } = useSelector(({ store }) => store)

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.SOFTBUNDLE_CARD_ACCESS_STORE)
    dispatch(setDrawer(DRAWER_KEY.STORE))
  }

  function renderContent() {
    if (!isEligibleToBuy) return null

    return (
      <BaseCard
        onClick={handleClick}
        text='Loja de serviços'
        icon={<STATICS.CART_CARD />}
        tag={SERVICES_CARDS_TAGS.NEW}
      />
    )
  }

  return renderContent()
}
